/* eslint-disable */
import React, {useState} from 'react';
import Modal from '../../component/Inc/Modal';
function PopClassPlan(props) {
  const {open, close} = props;
  return (
    <Modal open={open} close={close} type="pop_class_plan">
      <h2 className="pop_tit">수업 계획서</h2>
      <div className="content_container">
        <div className="com_info">
          <p className="name">김교사104</p>
          <span className="dot" />
          <p className="date">2023.05.20 11:30</p>
        </div>
        <div className="pop_board_tit">수업정보</div>
        <div className="com_board_box">
          <div className="board_item">
            <div className="info">
              <span className="cont">
                <button className="name">홍학생102 </button>
                <span className="desc dot">수업일 : 2023, 05, 16 15:30</span>
              </span>
            </div>
            <button type="button" className="icon_arrow_down" onClick={() => {}}></button>
          </div>
        </div>
        <div className="check">
          <input type="checkbox" id="chk01" className="com_chk" />
          <label htmlFor="chk01">전화 상담 여부</label>
        </div>
        <div className="com_board_box">
          <div className="board_item">
            상담 대상 : 김학생 부모 <br />
            상담 메모
          </div>
        </div>
        <div className="com_input_wrap flex_row">
          <select className="select">
            <option value="회차 선택">회차 선택</option>
          </select>
          <select className="select">
            <option value="수업 기획서 양식 선택">수업 기획서 양식 선택</option>
          </select>
        </div>
        <div className="alert_txt com_red_txt">* 수업 계획서 작성시 회별로 목표, 자세, 등 자세히 기입해 주세요.</div>
        <div className="com_board_box">
          <div className="board_item memo">
            <div className="editor">내용입력(에디터)</div>
            <table className="com_board_list">
              <colgroup>
                <col width="auto" />
                <col width="13%" />
                <col width="13%" />
                <col width="13%" />
                <col width="13%" />
                <col width="13%" />
                <col width="13%" />
              </colgroup>
              <tbody>
                <tr>
                  <th>
                    1주차
                    <br />
                    진도 및 과제
                  </th>
                  <td>
                    <div className="week">Monday</div>
                  </td>
                  <td>
                    <div className="week">Tuesday</div>
                  </td>
                  <td>
                    <div className="week">Wednesday</div>
                  </td>
                  <td>
                    <div className="week">Thursday</div>
                  </td>
                  <td>
                    <div className="week">Friday</div>
                  </td>
                  <td>
                    <div className="week com_blue_txt">Saturday</div>
                  </td>
                  <td>
                    <div className="week com_red_txt">Sunday</div>
                  </td>
                </tr>
              </tbody>
            </table>
            <table className="com_board_list">
              <colgroup>
                <col width="auto" />
                <col width="13%" />
                <col width="13%" />
                <col width="13%" />
                <col width="13%" />
                <col width="13%" />
                <col width="13%" />
              </colgroup>
              <tbody>
                <tr>
                  <th>
                    2주차
                    <br />
                    진도 및 과제
                  </th>
                  <td>
                    <div className="week">Monday</div>
                  </td>
                  <td>
                    <div className="week">Tuesday</div>
                  </td>
                  <td>
                    <div className="week">Wednesday</div>
                  </td>
                  <td>
                    <div className="week">Thursday</div>
                  </td>
                  <td>
                    <div className="week">Friday</div>
                  </td>
                  <td>
                    <div className="week com_blue_txt">Saturday</div>
                  </td>
                  <td>
                    <div className="week com_red_txt">Sunday</div>
                  </td>
                </tr>
              </tbody>
            </table>
            <table className="com_board_list">
              <colgroup>
                <col width="auto" />
                <col width="13%" />
                <col width="13%" />
                <col width="13%" />
                <col width="13%" />
                <col width="13%" />
                <col width="13%" />
              </colgroup>
              <tbody>
                <tr>
                  <th>
                    3주차
                    <br />
                    진도 및 과제
                  </th>
                  <td>
                    <div className="week">Monday</div>
                  </td>
                  <td>
                    <div className="week">Tuesday</div>
                  </td>
                  <td>
                    <div className="week">Wednesday</div>
                  </td>
                  <td>
                    <div className="week">Thursday</div>
                  </td>
                  <td>
                    <div className="week">Friday</div>
                  </td>
                  <td>
                    <div className="week com_blue_txt">Saturday</div>
                  </td>
                  <td>
                    <div className="week com_red_txt">Sunday</div>
                  </td>
                </tr>
              </tbody>
            </table>
            <table className="com_board_list">
              <colgroup>
                <col width="auto" />
                <col width="13%" />
                <col width="13%" />
                <col width="13%" />
                <col width="13%" />
                <col width="13%" />
                <col width="13%" />
              </colgroup>
              <tbody>
                <tr>
                  <th>
                    4주차
                    <br />
                    진도 및 과제
                  </th>
                  <td>
                    <div className="week">Monday</div>
                  </td>
                  <td>
                    <div className="week">Tuesday</div>
                  </td>
                  <td>
                    <div className="week">Wednesday</div>
                  </td>
                  <td>
                    <div className="week">Thursday</div>
                  </td>
                  <td>
                    <div className="week">Friday</div>
                  </td>
                  <td>
                    <div className="week com_blue_txt">Saturday</div>
                  </td>
                  <td>
                    <div className="week com_red_txt">Sunday</div>
                  </td>
                </tr>
              </tbody>
            </table>
            <div className="info_txt">
              1) 수업계획서 양식을 새롭게 만들어서 파일첨부형식이 아닌 버튼 클릭시 팝업 생성하여 erp상에서 바로 입력할 수 있도록 구현.
              <br />
              2) 수업계획서 입력 시, 안내메세지 강사에게 노출
              <br />
              [수업계획서는 해당 학생 및 학부모님에게 자동 전달 되오니, 상세하게 작성 부탁드립니다.]
              <br />
              3. 학생 및 학부모에게 어플로 확인가능하도록 알림
              <br />
              4) 강사가 해당학생 수업 check시 다음회차에 해당하는 수업계획서 강사에게 노출 되도록 설정
              <br />
              - 초기 작성한 해당주차 수업계획서 수정 가능 및 수정 내용 반영
              <br />
              - 추후 학습관리시스템 개발에 따라 해당 학습계획표를 연동하여 학생들이 매일매일 과제 달성여부를 체크하고 강사가 확인하며 학생관리 활용
              <br />* 첫수업 보고서 항목을 모두 기입해야만 제출 가능 및 첫수업보고서 제출시 첫수업 자동체크
            </div>
          </div>
        </div>
      </div>
      <div className="btn_container">
        <button className="com_btn orange xs">등록</button>
      </div>
    </Modal>
  );
}

export default PopClassPlan;
